import { INBOX_BODY_WARM_DEFER_MS, INBOX_CACHE_WINDOW_SIZE } from "@/lib/constants/inbox";
import { navFolderSlot } from "@/lib/mail/folderNavSections";
import { queueWarmMessageBodies } from "@/lib/mail/bodyWarmup";
import { isInboxArchiveInflight } from "@/lib/storage/inboxArchiveSession";
import type { MailMessageSummary } from "@/lib/types/mail";

const catchUpDoneKeys = new Set<string>();

function catchUpKey(accountId: number, folder: string): string {
  return `${accountId}\0${folder}`;
}

/**
 * Filet de sécurité : warm séquentiel des corps manquants dans la fenêtre DD02.
 * Une seule fois par compte/dossier/session — ne remplace pas notifyNewMailArrived.
 */
export function scheduleBodyCatchUp(
  accountId: number,
  folder: string,
  messages: MailMessageSummary[]
): void {
  // INBOX : archivage .eml DD02 (useInboxLocalStorageSync / worker) — pas de warm IMAP parallèle (R2).
  if (navFolderSlot(folder, "") === "inbox") return;
  if (isInboxArchiveInflight(accountId)) return;

  const key = catchUpKey(accountId, folder);
  if (catchUpDoneKeys.has(key)) return;
  catchUpDoneKeys.add(key);

  const warmUids = messages
    .slice(0, INBOX_CACHE_WINDOW_SIZE)
    .filter((m) => m.uid > 0 && m.bodyCached !== true)
    .map((m) => m.uid);

  if (warmUids.length === 0) return;

  window.setTimeout(() => {
    queueWarmMessageBodies(accountId, folder, warmUids, { newMail: true });
  }, INBOX_BODY_WARM_DEFER_MS);
}
